import type { ClassDefinition } from '../../shared/game/class-types.js';

// Shepherd 3.0 draft, level 1: Keeper of Life & Death (the Radiant and Necrotic cantrips) and My Buddy! (the Lifebinding Spirit).
// Mana, tiered spells, Sacred Graces and subclasses begin at later levels and are not implemented yet.
export const shepherd: ClassDefinition = {
  id: 'shepherd', name: 'Shepherd',
  summary: 'A pet-based support class that doles out healing and harm with equal mastery, beside a faithful spirit companion.',
  keyStats: ['will', 'strength'], hitDie: 10, startingHp: 17,
  saves: { advantage: ['will'], disadvantage: ['dexterity'] },
  armor: ['mail', 'shield'], weapons: ['strength'], weaponTypes: ['wand'],
  startingGear: ['Rusty Mail', 'Mace', 'Wooden Buckler', 'Bell'], weaponFirst: true,
  abilities: [
    {
      id: 'lifebinding-spirit', name: 'Lifebinding Spirit', level: 1, actions: 1, target: 'self', combatOnly: true, summons: true, autocast: true,
      description: 'Summon your spirit companion to your side for the rest of the fight. It cannot be harmed and acts on a target within Reach 4 of you, sharing your actions.',
    },
    {
      id: 'spirit-harm', name: 'Harm', level: 1, actions: 1, target: 'enemy', combatOnly: true, companion: true, autocast: true,
      description: 'Your spirit attacks a foe within Reach 4 of you for 1d8 + STR radiant damage, ignoring Armor, while you act.',
    },
    {
      id: 'spirit-mend', name: 'Mend', level: 1, actions: 1, target: 'ally', dyingTarget: true, combatOnly: true, companion: true, autocast: true,
      usesPerSafeRest: { stat: 'will', multiplier: 1 },
      description: 'Your spirit restores WIL d20 HP to a Dying creature within Reach 4 of you. WIL uses per Safe Rest.',
    },
    {
      id: 'rebuke', spell: true, name: 'Rebuke', level: 1, actions: 1, target: 'enemy', autocast: true, autoAttack: true,
      description: 'Radiant cantrip · Reach 4 · 1d8 radiant, ignoring Armor. Double damage against the undead and the Frightened.',
    },
    {
      id: 'withering-touch', spell: true, name: 'Withering Touch', level: 1, actions: 1, target: 'enemy', autocast: true, autoAttack: true,
      description: 'Necrotic cantrip · Reach 1 · 1d12 necrotic. On damage, the target counts as undead for one round.',
    },
    {
      id: 'true-strike', spell: true, name: 'True Strike', level: 1, actions: 1, target: 'ally', autocast: true,
      description: 'Radiant cantrip · Reach 4 · An ally’s next attack this encounter has advantage, ignores all disadvantage and reaches 1 further.',
    },
    {
      id: 'entice', spell: true, name: 'Entice', level: 1, actions: 1, target: 'creature', oncePerRound: true,
      description: 'Necrotic cantrip · Range 12 · 1d12 necrotic, ignoring Armor. The target is pulled Primary Die spaces toward you and deals 1d12 more on its next hit. Once per round.',
    },
  ],
  passives: [{
    id: 'keeper-of-life-and-death', name: 'Keeper of Life & Death', level: 1,
    description: 'You know the Radiant and Necrotic cantrips.',
  }],
};
